<template>
  <div class="container-fluid w-100" style="overflow: hidden">
    <navbar v-if="!editMode" :title="$t('api_keys.title')" />
    <div class="col-sm-12 nopads">
      <Transition name="fade">
        <api-keys-list
          :can-add="true"
          :results="results"
          @add="addKey"
          @edit="editKey"
        />
      </Transition>
        <base-modal v-if="editMode" hide-footer hide-header size="lg">
            <api-key-editor
                :key-to-edit="key"
                @close="showList"
                @close-and-update="closeAndUpdate"
            />
        </base-modal>

      <div
        v-if="loading"
        id="loader"
        class="spinner"
      />
    </div>
  </div>
</template>


<script>
import {restApi} from '../mixins/RestApiMixin'
import {apiKeyHelper} from '../mixins/ApiKeyMixin'
import ApiKeysList from "./ApiKeysList";
import ApiKeyEditor from "./ApiKeyEditor";
import Navbar from "@/components/utils/Navbar.vue";
import BaseModal from "@/components/BaseModal";

export default {
    name: 'ApiKeys',
    components: {BaseModal, Navbar, ApiKeyEditor, ApiKeysList},
    mixins: [restApi, apiKeyHelper],
    props: {
        userAccount: {
            type: Object,
            default: null
        }
    },
    data: function () {
        return {
            results: [],
            key: null,
            editMode: false,
            loading: true
        }
    },
    mounted: function () {
        this.fetchKeys()
    },
    methods: {
        fetchKeys: function () {
            this.loading = true
            this.restFetch(this.apiKeyUrl, this.handleResponse)
        },

        handleResponse: function (response) {
            this.loading = false
            this.results = response.data
        },

        editKey: function (key) {
            this.key = key
            this.editMode = true
        },

        addKey: function () {
            this.key = this.newApiKey()
            this.editMode = true
        },

        showList: function () {
            this.editMode = false
        },

        closeAndUpdate: function () {
            this.fetchKeys()
            this.showList()
        }
    }
}
</script>
